!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.Carousel = t() : e.Carousel = t();
}(self, () => (() => {
  var e = {
      858: e => {
        e.exports = function (e) {
          if (Array.isArray(e)) return e;
        };
      },
      646: e => {
        e.exports = function (e) {
          if (Array.isArray(e)) {
            for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
            return n;
          }
        };
      },
      575: e => {
        e.exports = function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        };
      },
      913: e => {
        function t(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        e.exports = function (e, n, r) {
          return n && t(e.prototype, n), r && t(e, r), e;
        };
      },
      860: e => {
        e.exports = function (e) {
          if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        };
      },
      884: e => {
        e.exports = function (e, t) {
          if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
            var n = [],
              r = !0,
              i = !1,
              o = void 0;
            try {
              for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
            } catch (e) {
              i = !0, o = e;
            } finally {
              try {
                r || null == s.return || s.return();
              } finally {
                if (i) throw o;
              }
            }
            return n;
          }
        };
      },
      521: e => {
        e.exports = function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      },
      206: e => {
        e.exports = function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        };
      },
      38: (e, t, n) => {
        var r = n(858),
          i = n(884),
          o = n(521);
        e.exports = function (e, t) {
          return r(e) || i(e, t) || o();
        };
      },
      319: (e, t, n) => {
        var r = n(646),
          i = n(860),
          o = n(206);
        e.exports = function (e) {
          return r(e) || i(e) || o();
        };
      },
      8: e => {
        function t(n) {
          return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? e.exports = t = function (e) {
            return typeof e;
          } : e.exports = t = function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, t(n);
        }
        e.exports = t;
      },
      846: e => {
        window, e.exports = function (e) {
          var t = {};
          function n(r) {
            if (t[r]) return t[r].exports;
            var i = t[r] = {
              i: r,
              l: !1,
              exports: {}
            };
            return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
          }
          return n.m = e, n.c = t, n.d = function (e, t, r) {
            n.o(e, t) || Object.defineProperty(e, t, {
              enumerable: !0,
              get: r
            });
          }, n.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
              value: "Module"
            }), Object.defineProperty(e, "__esModule", {
              value: !0
            });
          }, n.t = function (e, t) {
            if (1 & t && (e = n(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var r = Object.create(null);
            if (n.r(r), Object.defineProperty(r, "default", {
              enumerable: !0,
              value: e
            }), 2 & t && "string" != typeof e) for (var i in e) n.d(r, i, function (t) {
              return e[t];
            }.bind(null, i));
            return r;
          }, n.n = function (e) {
            var t = e && e.__esModule ? function () {
              return e.default;
            } : function () {
              return e;
            };
            return n.d(t, "a", t), t;
          }, n.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
          }, n.p = "", n(n.s = 3);
        }([function (e, t) {
          var n;
          n = function () {
            return this;
          }();
          try {
            n = n || new Function("return this")();
          } catch (e) {
            "object" == typeof window && (n = window);
          }
          e.exports = n;
        }, function (e, t, n) {
          "use strict";

          (function (e) {
            var r = n(2),
              i = setTimeout;
            function o() {}
            function a(e) {
              if (!(this instanceof a)) throw new TypeError("Promises must be constructed via new");
              if ("function" != typeof e) throw new TypeError("not a function");
              this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], p(e, this);
            }
            function s(e, t) {
              for (; 3 === e._state;) e = e._value;
              0 !== e._state ? (e._handled = !0, a._immediateFn(function () {
                var n = 1 === e._state ? t.onFulfilled : t.onRejected;
                if (null !== n) {
                  var r;
                  try {
                    r = n(e._value);
                  } catch (e) {
                    return void c(t.promise, e);
                  }
                  l(t.promise, r);
                } else (1 === e._state ? l : c)(t.promise, e._value);
              })) : e._deferreds.push(t);
            }
            function l(e, t) {
              try {
                if (t === e) throw new TypeError("A promise cannot be resolved with itself.");
                if (t && ("object" == typeof t || "function" == typeof t)) {
                  var n = t.then;
                  if (t instanceof a) return e._state = 3, e._value = t, void u(e);
                  if ("function" == typeof n) return void p((r = n, i = t, function () {
                    r.apply(i, arguments);
                  }), e);
                }
                e._state = 1, e._value = t, u(e);
              } catch (t) {
                c(e, t);
              }
              var r, i;
            }
            function c(e, t) {
              e._state = 2, e._value = t, u(e);
            }
            function u(e) {
              2 === e._state && 0 === e._deferreds.length && a._immediateFn(function () {
                e._handled || a._unhandledRejectionFn(e._value);
              });
              for (var t = 0, n = e._deferreds.length; t < n; t++) s(e, e._deferreds[t]);
              e._deferreds = null;
            }
            function d(e, t, n) {
              this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.promise = n;
            }
            function p(e, t) {
              var n = !1;
              try {
                e(function (e) {
                  n || (n = !0, l(t, e));
                }, function (e) {
                  n || (n = !0, c(t, e));
                });
              } catch (e) {
                if (n) return;
                n = !0, c(t, e);
              }
            }
            a.prototype.catch = function (e) {
              return this.then(null, e);
            }, a.prototype.then = function (e, t) {
              var n = new this.constructor(o);
              return s(this, new d(e, t, n)), n;
            }, a.prototype.finally = r.a, a.all = function (e) {
              return new a(function (t, n) {
                if (!e || void 0 === e.length) throw new TypeError("Promise.all accepts an array");
                var r = Array.prototype.slice.call(e);
                if (0 === r.length) return t([]);
                var i = r.length;
                function o(e, a) {
                  try {
                    if (a && ("object" == typeof a || "function" == typeof a)) {
                      var s = a.then;
                      if ("function" == typeof s) return void s.call(a, function (t) {
                        o(e, t);
                      }, n);
                    }
                    r[e] = a, 0 == --i && t(r);
                  } catch (e) {
                    n(e);
                  }
                }
                for (var a = 0; a < r.length; a++) o(a, r[a]);
              });
            }, a.resolve = function (e) {
              return e && "object" == typeof e && e.constructor === a ? e : new a(function (t) {
                t(e);
              });
            }, a.reject = function (e) {
              return new a(function (t, n) {
                n(e);
              });
            }, a.race = function (e) {
              return new a(function (t, n) {
                for (var r = 0, i = e.length; r < i; r++) e[r].then(t, n);
              });
            }, a._immediateFn = "function" == typeof e && function (t) {
              e(t);
            } || function (e) {
              i(e, 0);
            }, a._unhandledRejectionFn = function (e) {
              "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", e);
            }, t.a = a;
          }).call(this, n(5).setImmediate);
        }, function (e, t, n) {
          "use strict";

          t.a = function (e) {
            var t = this.constructor;
            return this.then(function (n) {
              return t.resolve(e()).then(function () {
                return n;
              });
            }, function (n) {
              return t.resolve(e()).then(function () {
                return t.reject(n);
              });
            });
          };
        }, function (e, t, n) {
          "use strict";

          function r(e) {
            return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
              return typeof e;
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
          }
          n(4);
          var i,
            o,
            a,
            s,
            l,
            c,
            u = n(8),
            d = (o = function (e) {
              return new Promise(function (t, n) {
                e = s(e), e = l(e);
                var r = window.XMLHttpRequest ? new window.XMLHttpRequest() : new window.ActiveXObject("Microsoft.XMLHTTP");
                r.open(e.method, e.url), r.setRequestHeader("X-Requested-With", "XMLHttpRequest"), Object.keys(e.headers).forEach(function (t) {
                  var n = e.headers[t];
                  r.setRequestHeader(t, n);
                });
                var i = e.ratio;
                r.upload.addEventListener("progress", function (t) {
                  var n = Math.round(t.loaded / t.total * 100),
                    r = Math.ceil(n * i / 100);
                  e.progress(r);
                }, !1), r.addEventListener("progress", function (t) {
                  var n = Math.round(t.loaded / t.total * 100),
                    r = Math.ceil(n * (100 - i) / 100) + i;
                  e.progress(r);
                }, !1), r.onreadystatechange = function () {
                  if (4 === r.readyState) {
                    var e = r.response;
                    try {
                      e = JSON.parse(e);
                    } catch (e) {}
                    var i = u.parseHeaders(r.getAllResponseHeaders()),
                      o = {
                        body: e,
                        code: r.status,
                        headers: i
                      };
                    200 === r.status ? t(o) : n(o);
                  }
                }, r.send(e.data);
              });
            }, a = function (e) {
              return e.method = "POST", o(e);
            }, s = function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              if (e.url && "string" != typeof e.url) throw new Error("Url must be a string");
              if (e.url = e.url || "", e.method && "string" != typeof e.method) throw new Error("`method` must be a string or null");
              if (e.method = e.method ? e.method.toUpperCase() : "GET", e.headers && "object" !== r(e.headers)) throw new Error("`headers` must be an object or null");
              if (e.headers = e.headers || {}, e.type && ("string" != typeof e.type || !Object.values(i).includes(e.type))) throw new Error("`type` must be taken from module's «contentType» library");
              if (e.progress && "function" != typeof e.progress) throw new Error("`progress` must be a function or null");
              if (e.progress = e.progress || function (e) {}, e.beforeSend = e.beforeSend || function (e) {}, e.ratio && "number" != typeof e.ratio) throw new Error("`ratio` must be a number");
              if (e.ratio < 0 || e.ratio > 100) throw new Error("`ratio` must be in a 0-100 interval");
              if (e.ratio = e.ratio || 90, e.accept && "string" != typeof e.accept) throw new Error("`accept` must be a string with a list of allowed mime-types");
              if (e.accept = e.accept || "*/*", e.multiple && "boolean" != typeof e.multiple) throw new Error("`multiple` must be a true or false");
              if (e.multiple = e.multiple || !1, e.fieldName && "string" != typeof e.fieldName) throw new Error("`fieldName` must be a string");
              return e.fieldName = e.fieldName || "files", e;
            }, l = function (e) {
              switch (e.method) {
                case "GET":
                  var t = c(e.data, i.URLENCODED);
                  delete e.data, e.url = /\?/.test(e.url) ? e.url + "&" + t : e.url + "?" + t;
                  break;
                case "POST":
                case "PUT":
                case "DELETE":
                case "UPDATE":
                  var n = function () {
                    return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).type || i.JSON;
                  }(e);
                  (u.isFormData(e.data) || u.isFormElement(e.data)) && (n = i.FORM), e.data = c(e.data, n), n !== d.contentType.FORM && (e.headers["content-type"] = n);
              }
              return e;
            }, c = function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              switch (arguments.length > 1 ? arguments[1] : void 0) {
                case i.URLENCODED:
                  return u.urlEncode(e);
                case i.JSON:
                  return u.jsonEncode(e);
                case i.FORM:
                  return u.formEncode(e);
                default:
                  return e;
              }
            }, {
              contentType: i = {
                URLENCODED: "application/x-www-form-urlencoded; charset=utf-8",
                FORM: "multipart/form-data",
                JSON: "application/json; charset=utf-8"
              },
              request: o,
              get: function (e) {
                return e.method = "GET", o(e);
              },
              post: a,
              transport: function (e) {
                return e = s(e), u.selectFiles(e).then(function (t) {
                  for (var n = new FormData(), r = 0; r < t.length; r++) n.append(e.fieldName, t[r], t[r].name);
                  return u.isObject(e.data) && Object.keys(e.data).forEach(function (t) {
                    var r = e.data[t];
                    n.append(t, r);
                  }), e.beforeSend && e.beforeSend(t), e.data = n, a(e);
                });
              },
              selectFiles: function (e) {
                return delete (e = s(e)).beforeSend, u.selectFiles(e);
              }
            });
          e.exports = d;
        }, function (e, t, n) {
          "use strict";

          n.r(t);
          var r = n(1);
          window.Promise = window.Promise || r.a;
        }, function (e, t, n) {
          (function (e) {
            var r = void 0 !== e && e || "undefined" != typeof self && self || window,
              i = Function.prototype.apply;
            function o(e, t) {
              this._id = e, this._clearFn = t;
            }
            t.setTimeout = function () {
              return new o(i.call(setTimeout, r, arguments), clearTimeout);
            }, t.setInterval = function () {
              return new o(i.call(setInterval, r, arguments), clearInterval);
            }, t.clearTimeout = t.clearInterval = function (e) {
              e && e.close();
            }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
              this._clearFn.call(r, this._id);
            }, t.enroll = function (e, t) {
              clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
            }, t.unenroll = function (e) {
              clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
            }, t._unrefActive = t.active = function (e) {
              clearTimeout(e._idleTimeoutId);
              var t = e._idleTimeout;
              t >= 0 && (e._idleTimeoutId = setTimeout(function () {
                e._onTimeout && e._onTimeout();
              }, t));
            }, n(6), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
          }).call(this, n(0));
        }, function (e, t, n) {
          (function (e, t) {
            !function (e, n) {
              "use strict";

              if (!e.setImmediate) {
                var r,
                  i,
                  o,
                  a,
                  s,
                  l = 1,
                  c = {},
                  u = !1,
                  d = e.document,
                  p = Object.getPrototypeOf && Object.getPrototypeOf(e);
                p = p && p.setTimeout ? p : e, "[object process]" === {}.toString.call(e.process) ? r = function (e) {
                  t.nextTick(function () {
                    f(e);
                  });
                } : function () {
                  if (e.postMessage && !e.importScripts) {
                    var t = !0,
                      n = e.onmessage;
                    return e.onmessage = function () {
                      t = !1;
                    }, e.postMessage("", "*"), e.onmessage = n, t;
                  }
                }() ? (a = "setImmediate$" + Math.random() + "$", s = function (t) {
                  t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(a) && f(+t.data.slice(a.length));
                }, e.addEventListener ? e.addEventListener("message", s, !1) : e.attachEvent("onmessage", s), r = function (t) {
                  e.postMessage(a + t, "*");
                }) : e.MessageChannel ? ((o = new MessageChannel()).port1.onmessage = function (e) {
                  f(e.data);
                }, r = function (e) {
                  o.port2.postMessage(e);
                }) : d && "onreadystatechange" in d.createElement("script") ? (i = d.documentElement, r = function (e) {
                  var t = d.createElement("script");
                  t.onreadystatechange = function () {
                    f(e), t.onreadystatechange = null, i.removeChild(t), t = null;
                  }, i.appendChild(t);
                }) : r = function (e) {
                  setTimeout(f, 0, e);
                }, p.setImmediate = function (e) {
                  "function" != typeof e && (e = new Function("" + e));
                  for (var t = new Array(arguments.length - 1), n = 0; n < t.length; n++) t[n] = arguments[n + 1];
                  var i = {
                    callback: e,
                    args: t
                  };
                  return c[l] = i, r(l), l++;
                }, p.clearImmediate = h;
              }
              function h(e) {
                delete c[e];
              }
              function f(e) {
                if (u) setTimeout(f, 0, e);else {
                  var t = c[e];
                  if (t) {
                    u = !0;
                    try {
                      !function (e) {
                        var t = e.callback,
                          n = e.args;
                        switch (n.length) {
                          case 0:
                            t();
                            break;
                          case 1:
                            t(n[0]);
                            break;
                          case 2:
                            t(n[0], n[1]);
                            break;
                          case 3:
                            t(n[0], n[1], n[2]);
                            break;
                          default:
                            t.apply(undefined, n);
                        }
                      }(t);
                    } finally {
                      h(e), u = !1;
                    }
                  }
                }
              }
            }("undefined" == typeof self ? void 0 === e ? this : e : self);
          }).call(this, n(0), n(7));
        }, function (e, t) {
          var n,
            r,
            i = e.exports = {};
          function o() {
            throw new Error("setTimeout has not been defined");
          }
          function a() {
            throw new Error("clearTimeout has not been defined");
          }
          function s(e) {
            if (n === setTimeout) return setTimeout(e, 0);
            if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);
            try {
              return n(e, 0);
            } catch (t) {
              try {
                return n.call(null, e, 0);
              } catch (t) {
                return n.call(this, e, 0);
              }
            }
          }
          !function () {
            try {
              n = "function" == typeof setTimeout ? setTimeout : o;
            } catch (e) {
              n = o;
            }
            try {
              r = "function" == typeof clearTimeout ? clearTimeout : a;
            } catch (e) {
              r = a;
            }
          }();
          var l,
            c = [],
            u = !1,
            d = -1;
          function p() {
            u && l && (u = !1, l.length ? c = l.concat(c) : d = -1, c.length && h());
          }
          function h() {
            if (!u) {
              var e = s(p);
              u = !0;
              for (var t = c.length; t;) {
                for (l = c, c = []; ++d < t;) l && l[d].run();
                d = -1, t = c.length;
              }
              l = null, u = !1, function (e) {
                if (r === clearTimeout) return clearTimeout(e);
                if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);
                try {
                  r(e);
                } catch (t) {
                  try {
                    return r.call(null, e);
                  } catch (t) {
                    return r.call(this, e);
                  }
                }
              }(e);
            }
          }
          function f(e, t) {
            this.fun = e, this.array = t;
          }
          function m() {}
          i.nextTick = function (e) {
            var t = new Array(arguments.length - 1);
            if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
            c.push(new f(e, t)), 1 !== c.length || u || s(h);
          }, f.prototype.run = function () {
            this.fun.apply(null, this.array);
          }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = m, i.addListener = m, i.once = m, i.off = m, i.removeListener = m, i.removeAllListeners = m, i.emit = m, i.prependListener = m, i.prependOnceListener = m, i.listeners = function (e) {
            return [];
          }, i.binding = function (e) {
            throw new Error("process.binding is not supported");
          }, i.cwd = function () {
            return "/";
          }, i.chdir = function (e) {
            throw new Error("process.chdir is not supported");
          }, i.umask = function () {
            return 0;
          };
        }, function (e, t, n) {
          function r(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }
          var i = n(9);
          e.exports = function () {
            function e() {
              !function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, e);
            }
            var t, n;
            return t = e, n = [{
              key: "urlEncode",
              value: function (e) {
                return i(e);
              }
            }, {
              key: "jsonEncode",
              value: function (e) {
                return JSON.stringify(e);
              }
            }, {
              key: "formEncode",
              value: function (e) {
                if (this.isFormData(e)) return e;
                if (this.isFormElement(e)) return new FormData(e);
                if (this.isObject(e)) {
                  var t = new FormData();
                  return Object.keys(e).forEach(function (n) {
                    var r = e[n];
                    t.append(n, r);
                  }), t;
                }
                throw new Error("`data` must be an instance of Object, FormData or <FORM> HTMLElement");
              }
            }, {
              key: "isObject",
              value: function (e) {
                return "[object Object]" === Object.prototype.toString.call(e);
              }
            }, {
              key: "isFormData",
              value: function (e) {
                return e instanceof FormData;
              }
            }, {
              key: "isFormElement",
              value: function (e) {
                return e instanceof HTMLFormElement;
              }
            }, {
              key: "selectFiles",
              value: function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return new Promise(function (t, n) {
                  var r = document.createElement("INPUT");
                  r.type = "file", e.multiple && r.setAttribute("multiple", "multiple"), e.accept && r.setAttribute("accept", e.accept), r.style.display = "none", document.body.appendChild(r), r.addEventListener("change", function (e) {
                    var n = e.target.files;
                    t(n), document.body.removeChild(r);
                  }, !1), r.click();
                });
              }
            }, {
              key: "parseHeaders",
              value: function (e) {
                var t = e.trim().split(/[\r\n]+/),
                  n = {};
                return t.forEach(function (e) {
                  var t = e.split(": "),
                    r = t.shift(),
                    i = t.join(": ");
                  r && (n[r] = i);
                }), n;
              }
            }], null && r(t.prototype, null), n && r(t, n), e;
          }();
        }, function (e, t) {
          var n = function (e) {
              return encodeURIComponent(e).replace(/[!'()*]/g, escape).replace(/%20/g, "+");
            },
            r = function (e, t, i, o) {
              return t = t || null, i = i || "&", o = o || null, e ? function (e) {
                for (var t = new Array(), n = 0; n < e.length; n++) e[n] && t.push(e[n]);
                return t;
              }(Object.keys(e).map(function (a) {
                var s,
                  l,
                  c = a;
                if (o && (c = o + "[" + c + "]"), "object" == typeof e[a] && null !== e[a]) s = r(e[a], null, i, c);else {
                  t && (l = c, c = !isNaN(parseFloat(l)) && isFinite(l) ? t + Number(c) : c);
                  var u = e[a];
                  u = (u = 0 === (u = !1 === (u = !0 === u ? "1" : u) ? "0" : u) ? "0" : u) || "", s = n(c) + "=" + n(u);
                }
                return s;
              })).join(i).replace(/[!'()*]/g, "") : "";
            };
          e.exports = r;
        }]);
      },
      387: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => s
        });
        var r = n(81),
          i = n.n(r),
          o = n(645),
          a = n.n(o)()(i());
        a.push([e.id, '.cdxcarousel-addImage {\r\n    height: 225px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 5px;\r\n    position: relative;\r\n    flex-direction: row;\r\n    margin-top: 5px;\r\n    user-select: none;\r\n}\r\n\r\n.cdxcarousel-item--empty .image-tool__image-preloader{\r\n  display: none;\r\n}\r\n\r\n.cdxcarousel-item img {\r\n    margin-bottom: 15px;\r\n    display: block;\r\n    object-fit: cover;\r\n    width: 100%;\r\n    height: 180px;\r\n    order: 1;\r\n}\r\n\r\n.cdxcarousel-inputUrl {\r\n    order: 0;\r\n    display: none;\r\n}\r\n\r\n.cdxcarousel-caption {\r\n    order: 3;\r\n}\r\n\r\n\r\n.cdxcarousel-block {\r\n    width: 50%;\r\n}\r\n\r\n.cdxcarousel-list {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    flex-direction: row;\r\n    justify-content: flex-start;\r\n    align-items: flex-start;\r\n}\r\n\r\n.cdxcarousel-wrapper {\r\n    margin-top: 10px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.cdxcarousel-item {\r\n    height: 235px;\r\n    padding: 5px;\r\n    display: flex;\r\n    position: relative;\r\n    flex-direction: column;\r\n}\r\n\r\n\r\n.cdxcarousel-removeBtn {\r\n    position: absolute;\r\n    padding: 3px;\r\n    right: 10px;\r\n    top: 10px;\r\n    display: inline-flex;\r\n    width: 34px;\r\n    height: 34px;\r\n    line-height: 34px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 3px;\r\n    cursor: pointer;\r\n    border: 0;\r\n    outline: none;\r\n    background-color: white;\r\n    color: #000;\r\n    transition: background 200ms;\r\n}\r\n\r\n.cdxcarousel-removeBtn:hover {\r\n    background: #eff2f5;\r\n}\r\n\r\n.cdxcarousel-leftBtn {\r\n  position: absolute;\r\n  padding: 3px;\r\n  right: 88px;\r\n  top: 10px;\r\n  display: inline-flex;\r\n  width: 34px;\r\n  height: 34px;\r\n  line-height: 34px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n  border: 0;\r\n  outline: none;\r\n  background-color: white;\r\n  color: #000;\r\n  transition: background 200ms;\r\n}\r\n\r\n.cdxcarousel-rightBtn {\r\n  position: absolute;\r\n  padding: 3px;\r\n  right: 49px;\r\n  top: 10px;\r\n  display: inline-flex;\r\n  width: 34px;\r\n  height: 34px;\r\n  line-height: 34px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n  border: 0;\r\n  outline: none;\r\n  background-color: white;\r\n  color: #000;\r\n  transition: background 200ms;\r\n}\r\n\r\n.column__setting__wrapper {\r\n    position: absolute;\r\n    right: -30px;\r\n    top: 30px;\r\n}\r\n.column-1 .cdxcarousel-block {\r\n    width: 100% !important;\r\n}\r\n.column-2 .cdxcarousel-block {\r\n    width: 50% !important;\r\n}\r\n.column-3 .cdxcarousel-block {\r\n    width: calc(100% / 3) !important;\r\n}\r\n.column-4 .cdxcarousel-block {\r\n    width: 25% !important;\r\n}\r\n.column-5 .cdxcarousel-block {\r\n    width: 20% !important;\r\n}\r\n\r\n.cdxcarousel-block {\r\n  width: 20% !important;\r\n}\r\n\r\n.cdxcarousel-item {\r\n  height: auto !important;\r\n}\r\n\r\n.cdxcarousel-item img {\r\n  height: 125px !important;\r\n}\r\n\r\n.cdxcarousel-addImage {\r\n  height: 123px !important;\r\n  margin: 5px !important;\r\n  padding: 0 !important;\r\n  border-radius: 0 !important;\r\n}\r\n\r\n.cdxcarousel-addImage:hover, .cdxcarousel-addImage:focus {\r\n  border-radius: 3px !important;\r\n}\r\n\r\n.image-tool__image {\r\n    border-radius: 3px;\r\n    overflow: hidden;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n.image-tool__image-picture {\r\n      max-width: 100%;\r\n      vertical-align: bottom;\r\n      display: block;\r\n    }\r\n\r\n.image-tool__image-preloader {\r\n      width: 50px;\r\n      height: 50px;\r\n      border-radius: 50%;\r\n      background-size: cover;\r\n      margin: auto;\r\n      position: relative;\r\n      background-color: #cdd1e0;\r\n      background-position: center center;\r\n    }\r\n\r\n.image-tool__image-preloader::after {\r\n        content: "";\r\n        position: absolute;\r\n        z-index: 3;\r\n        width: 60px;\r\n        height: 60px;\r\n        border-radius: 50%;\r\n        border: 2px solid #cdd1e0;\r\n        border-top-color: #388ae5;\r\n        left: 50%;\r\n        top: 50%;\r\n        margin-top: -30px;\r\n        margin-left: -30px;\r\n        animation: image-preloader-spin 2s infinite linear;\r\n        box-sizing: border-box;\r\n      }\r\n', ""]);
        const s = a;
      },
      645: e => {
        "use strict";

        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var n = "",
                r = void 0 !== t[5];
              return t[4] && (n += "@supports (".concat(t[4], ") {")), t[2] && (n += "@media ".concat(t[2], " {")), r && (n += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), n += e(t), r && (n += "}"), t[2] && (n += "}"), t[4] && (n += "}"), n;
            }).join("");
          }, t.i = function (e, n, r, i, o) {
            "string" == typeof e && (e = [[null, e, void 0]]);
            var a = {};
            if (r) for (var s = 0; s < this.length; s++) {
              var l = this[s][0];
              null != l && (a[l] = !0);
            }
            for (var c = 0; c < e.length; c++) {
              var u = [].concat(e[c]);
              r && a[u[0]] || (void 0 !== o && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), u[5] = o), n && (u[2] ? (u[1] = "@media ".concat(u[2], " {").concat(u[1], "}"), u[2] = n) : u[2] = n), i && (u[4] ? (u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}"), u[4] = i) : u[4] = "".concat(i)), t.push(u));
            }
          }, t;
        };
      },
      81: e => {
        "use strict";

        e.exports = function (e) {
          return e[1];
        };
      },
      86: (e, t, n) => {
        "use strict";

        var r = n(379),
          i = n.n(r),
          o = n(795),
          a = n.n(o),
          s = n(569),
          l = n.n(s),
          c = n(565),
          u = n.n(c),
          d = n(216),
          p = n.n(d),
          h = n(589),
          f = n.n(h),
          m = n(387),
          g = {};
        g.styleTagTransform = f(), g.setAttributes = u(), g.insert = l().bind(null, "head"), g.domAPI = a(), g.insertStyleElement = p(), i()(m.Z, g), m.Z && m.Z.locals && m.Z.locals;
      },
      379: e => {
        "use strict";

        var t = [];
        function n(e) {
          for (var n = -1, r = 0; r < t.length; r++) if (t[r].identifier === e) {
            n = r;
            break;
          }
          return n;
        }
        function r(e, r) {
          for (var o = {}, a = [], s = 0; s < e.length; s++) {
            var l = e[s],
              c = r.base ? l[0] + r.base : l[0],
              u = o[c] || 0,
              d = "".concat(c, " ").concat(u);
            o[c] = u + 1;
            var p = n(d),
              h = {
                css: l[1],
                media: l[2],
                sourceMap: l[3],
                supports: l[4],
                layer: l[5]
              };
            if (-1 !== p) t[p].references++, t[p].updater(h);else {
              var f = i(h, r);
              r.byIndex = s, t.splice(s, 0, {
                identifier: d,
                updater: f,
                references: 1
              });
            }
            a.push(d);
          }
          return a;
        }
        function i(e, t) {
          var n = t.domAPI(t);
          return n.update(e), function (t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap && t.supports === e.supports && t.layer === e.layer) return;
              n.update(e = t);
            } else n.remove();
          };
        }
        e.exports = function (e, i) {
          var o = r(e = e || [], i = i || {});
          return function (e) {
            e = e || [];
            for (var a = 0; a < o.length; a++) {
              var s = n(o[a]);
              t[s].references--;
            }
            for (var l = r(e, i), c = 0; c < o.length; c++) {
              var u = n(o[c]);
              0 === t[u].references && (t[u].updater(), t.splice(u, 1));
            }
            o = l;
          };
        };
      },
      569: e => {
        "use strict";

        var t = {};
        e.exports = function (e, n) {
          var r = function (e) {
            if (void 0 === t[e]) {
              var n = document.querySelector(e);
              if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
                n = n.contentDocument.head;
              } catch (e) {
                n = null;
              }
              t[e] = n;
            }
            return t[e];
          }(e);
          if (!r) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          r.appendChild(n);
        };
      },
      216: e => {
        "use strict";

        e.exports = function (e) {
          var t = document.createElement("style");
          return e.setAttributes(t, e.attributes), e.insert(t, e.options), t;
        };
      },
      565: (e, t, n) => {
        "use strict";

        e.exports = function (e) {
          var t = n.nc;
          t && e.setAttribute("nonce", t);
        };
      },
      795: e => {
        "use strict";

        e.exports = function (e) {
          var t = e.insertStyleElement(e);
          return {
            update: function (n) {
              !function (e, t, n) {
                var r = "";
                n.supports && (r += "@supports (".concat(n.supports, ") {")), n.media && (r += "@media ".concat(n.media, " {"));
                var i = void 0 !== n.layer;
                i && (r += "@layer".concat(n.layer.length > 0 ? " ".concat(n.layer) : "", " {")), r += n.css, i && (r += "}"), n.media && (r += "}"), n.supports && (r += "}");
                var o = n.sourceMap;
                o && "undefined" != typeof btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), t.styleTagTransform(r, e, t.options);
              }(t, e, n);
            },
            remove: function () {
              !function (e) {
                if (null === e.parentNode) return !1;
                e.parentNode.removeChild(e);
              }(t);
            }
          };
        };
      },
      589: e => {
        "use strict";

        e.exports = function (e, t) {
          if (t.styleSheet) t.styleSheet.cssText = e;else {
            for (; t.firstChild;) t.removeChild(t.firstChild);
            t.appendChild(document.createTextNode(e));
          }
        };
      },
      664: e => {
        e.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.15 13.628A7.749 7.749 0 0 0 10 17.75a7.74 7.74 0 0 0 6.305-3.242l-2.387-2.127-2.765 2.244-4.389-4.496-3.614 3.5zm-.787-2.303l4.446-4.371 4.52 4.63 2.534-2.057 3.533 2.797c.23-.734.354-1.514.354-2.324a7.75 7.75 0 1 0-15.387 1.325zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"></path></svg>';
      },
      66: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-columns" viewBox="0 0 16 16"><path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V2zm8.5 0v8H15V2H8.5zm0 9v3H15v-3H8.5zm-1-9H1v3h6.5V2zM1 14h6.5V6H1v8z"></path></svg>';
      },
      819: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-grid-3x3-gap" viewBox="0 0 16 16"><path d="M4 2v2H2V2h2zm1 12v-2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V7a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm5 10v-2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V7a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM9 2v2H7V2h2zm5 0v2h-2V2h2zM4 7v2H2V7h2zm5 0v2H7V7h2zm5 0h-2v2h2V7zM4 12v2H2v-2h2zm5 0v2H7v-2h2zm5 0v2h-2v-2h2zM12 1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zm-1 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2z"></path></svg>';
      },
      288: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-easel2" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8 0a.5.5 0 0 1 .447.276L8.81 1h4.69A1.5 1.5 0 0 1 15 2.5V11h.5a.5.5 0 0 1 0 1h-2.86l.845 3.379a.5.5 0 0 1-.97.242L12.11 14H3.89l-.405 1.621a.5.5 0 0 1-.97-.242L3.36 12H.5a.5.5 0 0 1 0-1H1V2.5A1.5 1.5 0 0 1 2.5 1h4.691l.362-.724A.5.5 0 0 1 8 0ZM2 11h12V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5V11Zm9.61 1H4.39l-.25 1h7.72l-.25-1Z"></path></svg>';
      }
    },
    t = {};
  function n(r) {
    var i = t[r];
    if (void 0 !== i) return i.exports;
    var o = t[r] = {
      id: r,
      exports: {}
    };
    return e[r](o, o.exports, n), o.exports;
  }
  n.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return n.d(t, {
      a: t
    }), t;
  }, n.d = (e, t) => {
    for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: t[r]
    });
  }, n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), n.nc = void 0;
  var r = {};
  return (() => {
    "use strict";

    n.d(r, {
      default: () => T
    });
    var e = n(319),
      t = n.n(e),
      i = n(8),
      o = n.n(i),
      a = n(575),
      s = n.n(a),
      l = n(913),
      c = n.n(l),
      u = n(38),
      d = n.n(u),
      p = n(846),
      h = n.n(p),
      f = function () {
        function e(t) {
          var n = t.config,
            r = t.onUpload,
            i = t.onError;
          s()(this, e), this.config = n, this.onUpload = r, this.onError = i;
        }
        return c()(e, [{
          key: "uploadSelectedFile",
          value: function (e) {
            var t = this,
              n = e.onPreview,
              r = function (e) {
                var t = new window.FileReader();
                t.readAsDataURL(e), t.onload = function (e) {
                  n(e.target.result);
                };
              };
            (this.config.uploader && "function" == typeof this.config.uploader.uploadByFile ? h().selectFiles({
              accept: this.config.types
            }).then(function (e) {
              r(e[0]);
              var n = t.config.uploader.uploadByFile(e[0]);
              return m(n), n;
            }) : h().transport({
              url: this.config.endpoints.byFile,
              data: this.config.additionalRequestData,
              accept: this.config.types,
              headers: this.config.additionalRequestHeaders,
              beforeSend: function (e) {
                r(e[0]);
              },
              fieldName: this.config.field
            }).then(function (e) {
              return e.body;
            })).then(function (e) {
              t.onUpload(e);
            }).catch(function (e) {
              t.onError(e);
            });
          }
        }, {
          key: "uploadByUrl",
          value: function (e) {
            var t,
              n = this;
            this.config.uploader && "function" == typeof this.config.uploader.uploadByUrl ? m(t = this.config.uploader.uploadByUrl(e)) : t = h().post({
              url: this.config.endpoints.byUrl,
              data: Object.assign({
                url: e
              }, this.config.additionalRequestData),
              type: h().contentType.JSON,
              headers: this.config.additionalRequestHeaders
            }).then(function (e) {
              return e.body;
            }), t.then(function (e) {
              n.onUpload(e);
            }).catch(function (e) {
              n.onError(e);
            });
          }
        }, {
          key: "uploadByFile",
          value: function (e, t) {
            var n,
              r = this,
              i = t.onPreview,
              o = new window.FileReader();
            if (o.readAsDataURL(e), o.onload = function (e) {
              i(e.target.result);
            }, this.config.uploader && "function" == typeof this.config.uploader.uploadByFile) m(n = this.config.uploader.uploadByFile(e));else {
              var a = new window.FormData();
              a.append(this.config.field, e), this.config.additionalRequestData && Object.keys(this.config.additionalRequestData).length && Object.entries(this.config.additionalRequestData).forEach(function (e) {
                var t = d()(e, 2),
                  n = t[0],
                  r = t[1];
                a.append(n, r);
              }), n = h().post({
                url: this.config.endpoints.byFile,
                data: a,
                type: h().contentType.JSON,
                headers: this.config.additionalRequestHeaders
              }).then(function (e) {
                return e.body;
              });
            }
            n.then(function (e) {
              r.onUpload(e);
            }).catch(function (e) {
              r.onError(e);
            });
          }
        }]), e;
      }();
    function m(e) {
      return window.Promise.resolve(e) === e;
    }
    var g = n(664),
      v = n.n(g),
      y = function () {
        function e(t) {
          var n = t.api,
            r = t.config,
            i = t.onSelectFile;
          s()(this, e), this.api = n, this.config = r, this.onSelectFile = i, this.nodes = {
            list: w("div", [this.CSS.baseClass]),
            item: w("div", [this.CSS.baseClass, this.CSS.wrapper]),
            wrapper: w("div", [this.CSS.baseClass, this.CSS.wrapper]),
            imageContainer: w("div", [this.CSS.imageContainer]),
            fileButton: this.createFileButton(),
            addButton: this.createAddButton(),
            imageEl: void 0,
            imagePreloader: w("div", this.CSS.imagePreloader),
            caption: w("div", [this.CSS.input, this.CSS.caption], {
              contentEditable: !0
            })
          }, this.nodes.caption.dataset.placeholder = this.config.captionPlaceholder, this.nodes.imageContainer.appendChild(this.nodes.imagePreloader), this.nodes.item.appendChild(this.nodes.imageContainer), this.nodes.item.appendChild(this.nodes.caption), this.nodes.item.appendChild(this.nodes.fileButton), this.nodes.list.appendChild(this.nodes.item), this.nodes.wrapper.appendChild(this.nodes.list), this.nodes.wrapper.appendChild(this.nodes.addButton);
        }
        return c()(e, [{
          key: "render",
          value: function (t) {
            return t.file && 0 !== Object.keys(t.file).length ? this.toggleStatus(e.status.UPLOADING) : this.toggleStatus(e.status.EMPTY), this.nodes.wrapper;
          }
        }, {
          key: "createAddButton",
          value: function () {
            var e = this,
              t = w("div", [this.CSS.button]);
            return t.innerHTML = this.config.buttonContent || "".concat(v(), " Add Image"), t.addEventListener("click", function () {
              e.nodes.list.appendChild();
            }), t;
          }
        }, {
          key: "createFileButton",
          value: function () {
            var e = this,
              t = w("div", [this.CSS.button]);
            return t.innerHTML = this.config.buttonContent || "".concat(v(), " ").concat(this.api.i18n.t("Add Image")), t.addEventListener("click", function () {
              e.onSelectFile();
            }), t;
          }
        }, {
          key: "showPreloader",
          value: function (t) {
            this.nodes.imagePreloader.style.backgroundImage = "url(".concat(t, ")"), this.toggleStatus(e.status.UPLOADING);
          }
        }, {
          key: "hidePreloader",
          value: function () {
            this.nodes.item.imagePreloader.style.backgroundImage = "", this.toggleStatus(e.status.EMPTY);
          }
        }, {
          key: "fillImage",
          value: function (t) {
            var n = this,
              r = /\.mp4$/.test(t) ? "VIDEO" : "IMG",
              i = {
                src: t
              },
              o = "load";
            "VIDEO" === r && (i.autoplay = !0, i.loop = !0, i.muted = !0, i.playsinline = !0, o = "loadeddata"), this.nodes.imageEl = w(r, this.CSS.imageEl, i), this.nodes.imageEl.addEventListener(o, function () {
              n.toggleStatus(e.status.FILLED), n.nodes.imagePreloader && (n.nodes.imagePreloader.style.backgroundImage = "");
            }), this.nodes.imageContainer.appendChild(this.nodes.imageEl);
          }
        }, {
          key: "fillCaption",
          value: function (e) {
            this.nodes.caption && (this.nodes.caption.innerHTML = e);
          }
        }, {
          key: "toggleStatus",
          value: function (t) {
            for (var n in e.status) e.status.hasOwnProperty(n) && this.nodes.item.classList.toggle("".concat(this.CSS.wrapper, "--").concat(e.status[n]), t === e.status[n]);
          }
        }, {
          key: "applyTune",
          value: function (e, t) {
            this.nodes.item.classList.toggle("".concat(this.CSS.wrapper, "--").concat(e), t);
          }
        }, {
          key: "CSS",
          get: function () {
            return {
              baseClass: this.api.styles.block,
              loading: this.api.styles.loader,
              input: this.api.styles.input,
              button: this.api.styles.button,
              wrapper: "image-tool",
              imageContainer: "image-tool__image",
              imagePreloader: "image-tool__image-preloader",
              imageEl: "image-tool__image-picture",
              caption: "image-tool__caption"
            };
          }
        }], [{
          key: "status",
          get: function () {
            return {
              EMPTY: "empty",
              UPLOADING: "loading",
              FILLED: "filled"
            };
          }
        }]), e;
      }(),
      w = function (e) {
        var n,
          r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          o = document.createElement(e);
        for (var a in Array.isArray(r) ? (n = o.classList).add.apply(n, t()(r)) : r && o.classList.add(r), i) o[a] = i[a];
        return o;
      },
      b = n(288),
      x = n.n(b),
      S = n(66),
      C = n.n(S),
      k = n(819),
      E = n.n(k),
      _ = function () {
        function e(t) {
          var n = t.api,
            r = t.onChange;
          s()(this, e), this.api = n, this.onChange = r, this.buttons = [];
        }
        return c()(e, [{
          key: "render",
          value: function (t) {
            var n = this,
              r = w("div", this.CSS.wrapper);
            return this.buttons = [], e.tunes.forEach(function (e) {
              var i = w("div", [n.CSS.buttonBase, n.CSS.button], {
                innerHTML: e.icon,
                title: e.title
              });
              i.addEventListener("click", function () {
                n.tuneClicked(e.name);
                var t = i.parentNode.querySelectorAll("." + n.CSS.buttonBase);
                Array.from(t).forEach(function (e) {
                  return e.classList.remove(n.CSS.buttonActive);
                }), i.classList.toggle(n.CSS.buttonActive);
              }), i.dataset.tune = e.name, i.classList.toggle(n.CSS.buttonActive, t.config === e.name), n.buttons.push(i), r.appendChild(i);
            }), r;
          }
        }, {
          key: "tuneClicked",
          value: function (e) {
            this.onChange(e);
          }
        }, {
          key: "CSS",
          get: function () {
            return {
              wrapper: "",
              buttonBase: this.api.styles.settingsButton,
              button: "image-tool__tune",
              buttonActive: this.api.styles.settingsButtonActive
            };
          }
        }], [{
          key: "isTune",
          get: function () {
            return !0;
          }
        }, {
          key: "tunes",
          get: function () {
            return [{
              name: "standard",
              icon: E(),
              title: "Standard Layout",
              default: !0
            }, {
              name: "carousel",
              icon: x(),
              title: "Enable Slide",
              default: !1
            }, {
              name: "masonry",
              icon: C(),
              title: "Enable Masonry",
              default: !1
            }];
          }
        }]), e;
      }();
    n(86).toString();
    var T = function () {
        function e(t) {
          var n = this,
            r = t.data,
            i = t.config,
            o = t.api,
            a = t.readOnly;
          s()(this, e), this.api = o, this._data = {
            items: [],
            config: _.tunes.find(function (e) {
              return !0 === e.default;
            }).name,
            countItemEachRow: 1
          }, this.data = r, this.IconClose = '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon--cross" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16"> <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/></svg>', this.IconLeft = '<svg xmlns="http://www.w3.org/2000/svg" class="icon " width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/></svg>', this.IconRight = '<svg xmlns="http://www.w3.org/2000/svg" class="icon " width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg>', this.IconPlus = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16"> <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/></svg>', this.IconMinus = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash" viewBox="0 0 16 16"> <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/></svg>', this.config = {
            endpoints: i.endpoints || "",
            additionalRequestData: i.additionalRequestData || {},
            additionalRequestHeaders: i.additionalRequestHeaders || {},
            field: i.field || "image",
            types: i.types || "image/*",
            captionPlaceholder: this.api.i18n.t("Caption"),
            buttonContent: i.buttonContent || "",
            uploader: i.uploader || void 0,
            actions: i.actions || [],
            galleryCallback: i.galleryCallback || {}
          }, this.uploader = new f({
            config: this.config,
            onUpload: function (e) {
              return n.onUpload(e);
            },
            onError: function (e) {
              return n.uploadingFailed(e);
            }
          }), this.ui = new y({
            api: o,
            config: this.config,
            onSelectFile: function () {
              n.uploader.uploadSelectedFile({
                onPreview: function (e) {
                  n.ui.showPreloader(e);
                }
              });
            },
            readOnly: a
          }), this.tunes = new _({
            api: o,
            actions: this.config.actions,
            onChange: function (e) {
              return n.tuneToggled(e);
            }
          });
        }
        return c()(e, null, [{
          key: "isReadOnlySupported",
          get: function () {
            return !0;
          }
        }]), c()(e, [{
          key: "render",
          value: function () {
            if (this.wrapper = L("div", [this.CSS.wrapper]), this.list = L("div", [this.CSS.list]), this.addButton = this.createAddButton(), this.list.appendChild(this.addButton), this.wrapper.appendChild(this.list), this._data.items.length > 0) {
              var e = !0,
                t = !1,
                n = void 0;
              try {
                for (var r, i = this._data.items[Symbol.iterator](); !(e = (r = i.next()).done); e = !0) {
                  var o = r.value,
                    a = this.creteNewItem(o.url, o.caption);
                  this.list.insertBefore(a, this.addButton);
                }
              } catch (e) {
                t = !0, n = e;
              } finally {
                try {
                  e || null == i.return || i.return();
                } finally {
                  if (t) throw n;
                }
              }
            }
            return this.wrapper.classList.add("column-" + this._data.countItemEachRow), this.wrapper;
          }
        }, {
          key: "save",
          value: function () {
            return this.data;
          }
        }, {
          key: "creteNewItem",
          value: function (e, t) {
            var n = this,
              r = L("div", [this.CSS.block]),
              i = L("div", [this.CSS.item, "items_column"]),
              o = L("div", [this.CSS.removeBtn]),
              a = L("div", [this.CSS.leftBtn]),
              s = L("div", [this.CSS.rightBtn]),
              l = L("input", [this.CSS.inputUrl]),
              c = L("div", [this.CSS.imagePreloader]);
            return l.value = e, a.innerHTML = this.IconLeft, a.style = "padding: 8px;", a.addEventListener("click", function () {
              var e = Array.from(r.parentNode.children).indexOf(r);
              0 != e && r.parentNode.insertBefore(r, r.parentNode.children[e - 1]);
            }), s.innerHTML = this.IconRight, s.style = "padding: 8px;", s.addEventListener("click", function () {
              var e = Array.from(r.parentNode.children).indexOf(r);
              e != r.parentNode.children.length - 2 && r.parentNode.insertBefore(r, r.parentNode.children[e + 2]);
            }), o.innerHTML = this.IconClose, o.addEventListener("click", function () {
              r.remove(), "" === n.config.endpoints.removeImage && void 0 === n.config.endpoints.removeImage || n.removeImage(r.querySelector("img").getAttribute("src"));
            }), o.style.display = "none", i.appendChild(l), i.appendChild(o), i.appendChild(a), i.appendChild(s), r.appendChild(i), e ? this._createImage(e, i, t, o) : i.appendChild(c), r;
          }
        }, {
          key: "_createImage",
          value: function (e, t, n, r) {
            var i = document.createElement("img"),
              o = L("div", [this.CSS.caption, this.CSS.input]);
            i.src = e, o.contentEditable = !0, o.innerHTML = n || "", r.style.display = "flex", t.appendChild(i), t.appendChild(o);
          }
        }, {
          key: "onUpload",
          value: function (e) {
            e.success && e.file ? (this._createImage(e.file.url, this.list.childNodes[this.list.childNodes.length - 2].firstChild, "", this.list.childNodes[this.list.childNodes.length - 2].firstChild.childNodes[1]), this.list.childNodes[this.list.childNodes.length - 2].firstChild.childNodes[2].style.backgroundImage = "", this.list.childNodes[this.list.childNodes.length - 2].firstChild.firstChild.value = e.file.url, this.list.childNodes[this.list.childNodes.length - 2].firstChild.classList.add("cdxcarousel-item--empty")) : this.uploadingFailed("incorrect response: " + JSON.stringify(e));
          }
        }, {
          key: "removeImage",
          value: function (e) {
            h().post({
              url: this.config.endpoints.removeImage,
              data: {
                image: e
              },
              mode: "same-origin",
              type: h().contentType.FORM,
              headers: Object.assign({
                "X-CSRFToken": document.querySelector("[name=csrf-token]").getAttribute("content")
              }, this.config.additionalRequestHeaders)
            }).then(function (e) {
              e.body;
            }).catch(function (e) {
              e.body;
            });
          }
        }, {
          key: "uploadingFailed",
          value: function () {
            this.api.notifier.show({
              message: this.api.i18n.t("Can not upload an image, try another"),
              style: "error"
            });
          }
        }, {
          key: "tuneToggled",
          value: function (e) {
            this.setTune(e, this._data.config !== e), this._data.config = e;
          }
        }, {
          key: "setTune",
          value: function (e, t) {
            this.applyTune(e, t);
          }
        }, {
          key: "applyTune",
          value: function (e, t) {
            this.wrapper.classList.toggle("".concat(this.CSS.wrapper, "--").concat(e), t);
          }
        }, {
          key: "renderSettings",
          value: function () {
            return this.tunes.render(this._data);
          }
        }, {
          key: "showPreloader",
          value: function (e) {
            this.nodes.imagePreloader.style.backgroundImage = "url(".concat(e, ")");
          }
        }, {
          key: "onSelectFile",
          value: function () {
            var e = this;
            this.uploader.uploadSelectedFile({
              onPreview: function (t) {
                var n = e.creteNewItem("", "");
                n.firstChild.lastChild.style.backgroundImage = "url(".concat(t, ")"), e.list.insertBefore(n, e.addButton);
              }
            });
          }
        }, {
          key: "createAddButton",
          value: function () {
            var e = this,
              t = L("div", [this.CSS.button, this.CSS.addButton]),
              n = L("div", [this.CSS.block]),
              r = L("div", [this.CSS.leftBtn, this.CSS.columnSetting]),
              i = L("div", [this.CSS.rightBtn, this.CSS.columnSetting]),
              a = L("div", [this.CSS.item, "column__setting__wrapper"]);
            return a.dataset.index = this._data.countItemEachRow ? this._data.countItemEachRow : 1, r.innerHTML = this.IconPlus, r.style = "padding: 4px; right:  0;", r.addEventListener("click", function () {
              e._data.countItemEachRow < 5 && (a.dataset.index++, e.setCountItemEachRow(a.dataset.index));
            }), i.innerHTML = this.IconMinus, i.style = "padding: 4px; right: 0px; top: 45px;", i.addEventListener("click", function () {
              e._data.countItemEachRow > 1 && (a.dataset.index--, e.setCountItemEachRow(a.dataset.index));
            }), t.innerHTML = "".concat(v(), " Add Image"), t.addEventListener("click", function () {
              "function" == typeof window[e.config.galleryCallback] && "object" === o()(window[e.config.galleryCallback]()) && Object.assign(e.config.additionalRequestData, window[e.config.galleryCallback]()), e.onSelectFile();
            }), a.appendChild(r), a.appendChild(i), n.appendChild(a), n.appendChild(t), n;
          }
        }, {
          key: "setCountItemEachRow",
          value: function (e) {
            this._data.countItemEachRow = e, this.wrapper.classList.remove("column-1", "column-2", "column-3", "column-4", "column-5"), this.wrapper.classList.add("column-" + e);
          }
        }, {
          key: "CSS",
          get: function () {
            return {
              baseClass: this.api.styles.block,
              loading: this.api.styles.loader,
              input: this.api.styles.input,
              button: this.api.styles.button,
              wrapper: "cdxcarousel-wrapper",
              addButton: "cdxcarousel-addImage",
              block: "cdxcarousel-block",
              item: "cdxcarousel-item",
              removeBtn: "cdxcarousel-removeBtn",
              leftBtn: "cdxcarousel-leftBtn",
              rightBtn: "cdxcarousel-rightBtn",
              inputUrl: "cdxcarousel-inputUrl",
              caption: "cdxcarousel-caption",
              list: "cdxcarousel-list",
              imagePreloader: "image-tool__image-preloader",
              columnSetting: "column__setting"
            };
          }
        }, {
          key: "data",
          set: function (e) {
            e || (e = {}), this._data.config = e.config || _.tunes.find(function (e) {
              return !0 === e.default;
            }).name, this._data.items = e.items || [], this._data.countItemEachRow = e.countItemEachRow || 1;
            var t = this.wrapper;
            t && t.parentNode.replaceChild(this.render(), t);
          },
          get: function () {
            this._data.items = [];
            var e = this.wrapper.getElementsByClassName(this.CSS.item),
              t = this.wrapper.querySelector(".column__setting__wrapper");
            if (e.length > 0) {
              var n = !0,
                r = !1,
                i = void 0;
              try {
                for (var o, a = e[Symbol.iterator](); !(n = (o = a.next()).done); n = !0) {
                  var s = o.value;
                  s.firstChild.value && this._data.items.push({
                    url: s.firstChild.value,
                    caption: s.querySelector(".cdxcarousel-caption.cdx-input[contenteditable]").innerHTML || ""
                  });
                }
              } catch (e) {
                r = !0, i = e;
              } finally {
                try {
                  n || null == a.return || a.return();
                } finally {
                  if (r) throw i;
                }
              }
            }
            return this._data.countItemEachRow = t.dataset.index, this._data;
          }
        }], [{
          key: "toolbox",
          get: function () {
            return {
              title: "Carousel",
              icon: '<svg width="38" height="18" viewBox="0 0 38 18" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="10" y="0" width="18" height="18"><path fill-rule="evenodd" clip-rule="evenodd" d="M28 16V2C28 0.9 27.1 0 26 0H12C10.9 0 10 0.9 10 2V16C10 17.1 10.9 18 12 18H26C27.1 18 28 17.1 28 16V16ZM15.5 10.5L18 13.51L21.5 9L26 15H12L15.5 10.5V10.5Z"  /></mask><g mask="url(#mask0)"><rect x="10" width="18" height="18"  /></g><mask id="mask1" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="3" width="7" height="12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 13.59L2.67341 9L7 4.41L5.66802 3L0 9L5.66802 15L7 13.59Z" fill="white"/></mask><g mask="url(#mask1)"><rect y="3" width="7.55735" height="12"  /></g><mask id="mask2" mask-type="alpha" maskUnits="userSpaceOnUse" x="31" y="3" width="7" height="12"><path fill-rule="evenodd" clip-rule="evenodd" d="M31 13.59L35.3266 9L31 4.41L32.332 3L38 9L32.332 15L31 13.59Z" fill="white"/></mask><g mask="url(#mask2)"><rect x="30.4426" y="2.25" width="7.55735" height="13" /></g></svg>'
            };
          }
        }]), e;
      }(),
      L = function (e) {
        var n,
          r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          o = document.createElement(e);
        for (var a in Array.isArray(r) ? (n = o.classList).add.apply(n, t()(r)) : r && o.classList.add(r), i) o[a] = i[a];
        return o;
      };
  })(), r.default;
})());